/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AssignAvisoDePrivacidadeAliases {
  ASSIGN_AVISO_DE_PRIVACIDADE_MODAL = 'assign-aviso-de-privacidade-modal',
  FETCH_HPMS_AVISO = 'fetch-hpms-aviso',
  HPMS_AVISO_SERVICE = 'hpms-aviso-service',
  PANEL_0 = 'panel-0',
}
export { AssignAvisoDePrivacidadeAliases };
